module.exports = __webpack_public_path__ + "img/29065909000100.80228fa2.png";